import React, { useState, useEffect } from 'react'
import './AddCandidate.css'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link, useNavigate } from 'react-router-dom'

export const AddCandidate = () => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  const [Phone, setPhone] = useState('')
  const [position, setPosition] = useState([])
  const [file, setFile] = useState(null)

  const token = localStorage.getItem('token')
  // set values of input
  const [data, setData] = useState({
    name: '',
    email: '',
    currentLocation: '',
    permanentLocation: '',
    position: '',
    experience: '',
    currentOrganization: '',
    noticePeriod: '',
    reasonOfJobChange: '',
    linkedin: '',
    resume: '',
  })

  // onchange func for input fields
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }

  // submit request to register candidate manually
  const postData = async (e) => {
    e.preventDefault()
    await axios
      .post(
        Baseurl.nodeLocal + 'candidate/saveManualFormData',

        {
          candidate_name: data.name,
          email: data.email,
          contact: Phone,
          designation: data.position,
          relevant_it_experience: data.experience,
          current_organisation: data.currentOrganization,
          current_location: data.currentLocation,
          permanent_place: data.permanentLocation,
          notice_period: data.noticePeriod,
          reason_for_job_change: data.reasonOfJobChange,
          candidate_linkedin: data.linkedin,
          candidate_resume: data.resume,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        if (err.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  // add excel file of candidate details
  const importCandidate = async (e) => {
    e.preventDefault()
    const formdata = new FormData()

    formdata.append('candidateDetails', file)
    await axios
      .post(Baseurl.nodeLocal + 'candidate/importCandidateFile', formdata)
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
      })
  }
  // fetch all positions
  const getvalues = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchPositions')
      .then((res) => {
        setPosition(res.data.data)
      })
      .catch((error) => {})
  }
  useEffect(() => {
    getvalues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Sidebar />

      <div className="container addCandidate p-4 ">
        <div className=" mt-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home" className="link text-primary">
                  Home
                </Link>
              </li>

              <li className="breadcrumb-item active" aria-current="page">
                Add Candidate
              </li>
            </ol>
          </nav>
        </div>
        <div className="card addCandidateCard mt-3 p-4">
          <h5 className="mb-4 text-primary">Add Candidate</h5>
          <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
            Import Candidate File
          </h6>
          <form onSubmit={importCandidate}>
            <div className="row p-2">
              <input
                className="form-control col-md"
                type="file"
                accept=".xls,.xlsx"
                onChange={(e) => {
                  setFile(e.target.files[0])
                }}
                required
              />
              <div className="col-md d-flex justify-content-end">
                <button className="btn btn-primary" type="submit">
                  Upload
                </button>
              </div>
            </div>
          </form>
          <div className="row g-2">
            <h6 className="m-b-20 p-b-5 b-b-default f-w-600 mt-4">
              Add Candidate
            </h6>
            <form onSubmit={postData}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Name"
                      name="name"
                      onChange={handleChange}
                      value={data.name}
                      required
                    />
                    <label htmlFor="floatingInputGrid">Name</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="email"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Email address"
                      name="email"
                      onChange={handleChange}
                      value={data.email}
                      required
                    />
                    <label htmlFor="floatingInputGrid">Email address</label>
                  </div>

                  <div className="form-floating mb-2">
                    <PhoneInput
                      country={'in'}
                      value={Phone}
                      onChange={setPhone}
                      enableSearch
                      inputStyle={{ width: '100%', height: '3.59rem' }}
                    />
                    {/* <label htmlFor="floatingInputGrid">Phone/Mobile</label> */}
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Current Location"
                      name="currentLocation"
                      onChange={handleChange}
                      value={data.currentLocation}
                      required
                    />
                    <label htmlFor="floatingInputGrid">Current Location</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Permanent/Native Location"
                      name="permanentLocation"
                      onChange={handleChange}
                      value={data.permanentLocation}
                      required
                    />
                    <label htmlFor="floatingInputGrid">
                      Permanent/Native Location
                    </label>
                  </div>

                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      name="position"
                      onChange={handleChange}
                      value={data.position}
                      required
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      {position?.map((i, index) => {
                        return (
                          <option value={i.value} key={index}>
                            {i.name}
                          </option>
                        )
                      })}
                    </select>
                    <label htmlFor="floatingSelect">Position</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Relevant Experience in the industry"
                      name="experience"
                      onChange={handleChange}
                      value={data.experience}
                      required
                    />
                    <label htmlFor="floatingInputGrid">
                      Relevant Experience in the industry
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Current Organization"
                      name="currentOrganization"
                      onChange={handleChange}
                      value={data.currentOrganization}
                      required
                    />
                    <label htmlFor="floatingInputGrid">
                      Current Organization
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Notice Period"
                      name="noticePeriod"
                      onChange={handleChange}
                      value={data.noticePeriod}
                      required
                    />
                    <label htmlFor="floatingInputGrid">Notice Period</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Reason for job Change"
                      name="reasonOfJobChange"
                      onChange={handleChange}
                      value={data.reasonOfJobChange}
                      required
                    />
                    <label htmlFor="floatingInputGrid">
                      Reason for job Change
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Linkedin Profile"
                      name="linkedin"
                      onChange={handleChange}
                      value={data.linkedin}
                    />
                    <label htmlFor="floatingInputGrid">Linkedin Profile</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Resume"
                      name="resume"
                      onChange={handleChange}
                      value={data.resume}
                      required
                    />
                    <label htmlFor="floatingInputGrid">Resume</label>
                  </div>
                </div>
              </div>
              <div className="row d-flex justify-content-end w-100">
                <div className="d-grid gap-2 col-2 mt-5">
                  <button className="btn btn-primary">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
